import React from "react"

import { Helmet } from "react-helmet";
import { Col, Row, Carousel } from "antd";

// import Layout from "@components/Layout";
import Header from "@components/header";
import Footer from "@components/footer";
import { useI18n } from "@src/i18n";

import * as styles from "./index.module.scss"


function CenteredLogo({ imgPath, style }) {
    return <div className="centered_logo" style={{ ...style ,textAlign:"center"}}>
        <img src={imgPath} alt="centereimg" />
    </div>
}


function FlexBox({ children, style }) {
    return <div className={styles.flex_box} style={{ ...style }}>
        {children}
    </div>
}

function Flex1Item({ title, details, data }) {
    return <div className={styles.flex1_item}>
        {data && <div className={styles.data}>{data.main}<span>{data.extra}</span></div>}
        {title && <div className={styles.second_title} style={{ marginBottom: "20px" }}>{title}</div>}
        <div className={styles.text} style={{ lineHeight: "30px" }}>{details}</div>
    </div>
}

function FlexItem({ style, imgPath, title, details }) {
    return <div className={styles.flex_item} style={{ ...style, textAlign: "center" }}>
        <img src={imgPath} alt="img" style={{ width: "70px", height: "70px" }} />
        <div className={styles.second_title} style={{ marginTop: "20px" }}>{title}</div>
        <div className={styles.text} style={{ marginTop: "20px", fontSize: "14px", textAlign: "center" }} >{details}</div>
    </div>
}

function Title({ children, style }) {
    return <div className={styles.title} style={{ ...style }}>{children}</div>
}

function getImg(name) {
    return require(`@images/advertising/${name}.png`).default
}

//适配移动端
function CardShadow({ children }) {
    return <div className={styles.card_shadow}>
        {children}
    </div>
}
export default function Advertising() {
    const { t } = useI18n();
    const facebookData1 = t("advertisingPage.facebookData1");
    const facebookData2 = t("advertisingPage.facebookData2").map((item, index) => ({
        ...item,
        img: `icon${index + 1}`,
    }));
    const googleData1 = t("advertisingPage.googleData1");
    const googleData2 = t("advertisingPage.googleData2").map((item, index) => ({
        ...item,
        img: `icon${index + 9}`,
    }));
    const bingData1 = t("advertisingPage.bingData1");
    const bingData2 = t("advertisingPage.bingData2");
    const ourserviseData = t("advertisingPage.ourServiceData").map((item, index) => ({
        ...item,
        img: `icon${index + 14}`,
    }));
    return <>
        <Header />
        <Helmet title={t("advertisingPage.title")} />
        <div className={styles.advertising}>
            {/* facebook  */}
            <div id='facebook' />
            <CenteredLogo imgPath={getImg('facebook')} />
            <Row>
                <Col md={24} sm={0} xs={0}>
                    <FlexBox style={{ marginTop: "30px" }}>
                        {facebookData1.map((item, index) => <Flex1Item data={item.data} details={item.details} key={index} />)}
                    </FlexBox></Col>
                <Col md={0} sm={24} xs={24}>
                    <Carousel>
                        {
                            facebookData1.map((item, index) => <div key={index} className={styles.card_out}>
                                <CardShadow>
                                    <Flex1Item data={item.data} details={item.details} />
                                </CardShadow >
                            </div>)
                        }

                    </Carousel>
                </Col>
            </Row>

            <Title style={{ marginTop: "40px" }}>{t("advertisingPage.facebookService")}</Title>
            <FlexBox style={{ flexWrap: "wrap" }}>
                {facebookData2.map((item, index) =>
                    <FlexItem key={index} imgPath={getImg(item.img)} title={item.title} details={item.details}
                    />)}
            </FlexBox>

            {/* google */}

            <div id='google' />
            <div style={{ backgroundColor: "#F9FBFE", padding: "1px" }}>
                <CenteredLogo imgPath={getImg("google")} style={{ marginTop: "60px" }} />
                <Row>
                    <Col md={24} sm={0} xs={0}>
                        <FlexBox style={{ marginTop: "30px" }}>
                            {googleData1.map((item, index) => <Flex1Item title={item.title} details={item.details} key={index} />)}
                        </FlexBox></Col>
                    <Col md={0} sm={24} xs={24}>
                        <Carousel>
                            {
                                googleData1.map((item, index) => <div key={index} className={styles.card_out}>
                                    <CardShadow>
                                        <Flex1Item title={item.title} details={item.details} />
                                    </CardShadow >
                                </div>)
                            }
                        </Carousel>
                    </Col>
                </Row>
                <Title style={{ marginTop: "40px" }}>{t("advertisingPage.googleService")}</Title>
                <FlexBox>
                    {googleData2.map((item, index) =>
                        <FlexItem key={index} imgPath={getImg(item.img)} title={item.title} details={item.details}
                        />)}
                </FlexBox>
            </div>

            {/* bing */}
            <div id='bing' />
            <CenteredLogo imgPath={getImg("bing")} style={{ marginTop: "40px" }} />


            <Row>
                <Col md={24} sm={0} xs={0}>
                    <FlexBox style={{ marginTop: "30px" }}>
                        {bingData1.map((item, index) => <Flex1Item title={item.title} details={item.details} key={index} />)}
                    </FlexBox></Col>
                <Col md={0} sm={24} xs={24}>
                    <Carousel>
                        {
                            bingData1.map((item, index) => <div key={index} className={styles.card_out}>
                                <CardShadow>
                                    <Flex1Item title={item.title} details={item.details} />
                                </CardShadow >
                            </div>)
                        }

                    </Carousel>
                </Col>
            </Row>

            <div className={styles.bing_second}>{t("advertisingPage.bingNetwork")}</div>

            <Row>
                <Col md={24} sm={0} xs={0}>
                    <div className={styles.earthContainer}>
                        <div>
                            <img src={getImg("earth")} alt="earth" />
                        </div>
                        <FlexBox style={{ position: "absolute", bottom: "-46px", width: "100%" }}>
                            {
                                bingData2.map(item =>
                                    <div className={styles.bing_item} key={item.head}>
                                        <div className={styles.head}>{item.head}</div>
                                        <div style={{ backgroundColor: "rgba(255,255,255,.8)", padding: "1px" }}>
                                            <div className={styles.added} style={{ marginTop: "30px" }}>{item.percentage}</div>
                                            <div className={styles.overhere}>{t("advertisingPage.searchMarketShare")}</div>
                                            <div className={styles.added} style={{ marginTop: "20px" }}>{item.data}</div>
                                            <div className={styles.overhere} style={{ marginBottom: "30px" }}>{t("advertisingPage.monthlySearch")}</div>
                                        </div>
                                    </div>
                                )
                            }
                        </FlexBox>
                    </div>
                </Col>
                <Col md={0} sm={24} xs={24}>
                    <FlexBox style={{ padding: "30px 20px", justifyContent: "space-between" }}>
                        {
                            bingData2.map(item =>
                                <div className={styles.bing_item} key={item.head} style={{ width: "160px" }}>
                                    <div className={styles.head}>{item.head}</div>
                                    <div style={{ backgroundColor: "rgba(255,255,255,.8)", padding: "1px" }}>
                                        <div className={styles.added} style={{ marginTop: "30px" }}>{item.percentage}</div>
                                        <div className={styles.overhere}>{t("advertisingPage.searchMarketShare")}</div>
                                        <div className={styles.added} style={{ marginTop: "20px" }}>{item.data}</div>
                                        <div className={styles.overhere} style={{ marginBottom: "30px" }}>{t("advertisingPage.monthlySearch")}</div>
                                    </div>
                                </div>
                            )
                        }
                    </FlexBox>
                </Col>
            </Row>


            {/* 我们的服务*/}

            <div id='our' />
            <Row>
                <Col md={24} sm={0} xs={0}>
                    <div className={styles.ourservise}>
                        <img src={getImg('ourservise')} alt="" />
                        <h1>{t("advertisingPage.ourService")}</h1>
                        <h3>{t("advertisingPage.serviceSubtitle")}</h3>
                    </div>
                </Col>
                <Col md={0} sm={24} xs={24}>
                    <div className={styles.ourservise_mobile}>
                        <img src={getImg('ourservise_mobile')} alt="" />
                        <h1>{t("advertisingPage.ourService")}</h1>
                        <h3>{t("advertisingPage.serviceSubtitle")}</h3>
                    </div>
                </Col>
            </Row>


            <FlexBox style={{ flexWrap: "wrap" }}>
                {ourserviseData.map((item, index) =>
                    <FlexItem key={index} imgPath={getImg(item.img)} title={item.title} details={item.details}
                    />)}
            </FlexBox>
            {/* <div className={styles.consult_now}>
                <div className={styles.left}>立即咨询</div>
                <div className={styles.right}>bd@fancyint.com</div>
            </div> */}
        </div>
        <Footer />
    </>
}
